import {createContext} from "react";

// This context stores the execution tree instance information.
const BehavioralExecutionTreeInstanceContext = createContext();

export default BehavioralExecutionTreeInstanceContext;
